/**
 * Shape check for an integer amount string from an upstream API before it is parsed with `BigInt`:
 * non-negative digits only, with no sign, point or exponent. It cannot tell which unit the digits
 * are in; the caller knows that.
 */

const BASE_UNITS = /^[0-9]+$/;

/** Stricter than `BigInt` itself, which also accepts `""`, `" 1"` and `"0x10"`. */
export const isBaseUnits = (value: string): boolean => BASE_UNITS.test(value);

export const baseUnitsOrNull = (value: string | null | undefined): string | null =>
  value !== null && value !== undefined && isBaseUnits(value) ? value : null;
